import style from "css/myreservation.module.css";
import { ReactComponent as Avatar } from "asset/calendar/avatarIcon_white.svg";
import { useNavigate } from "react-router-dom";

function PersonalCard({ colleague, isHotdesking }) {
  const navigate = useNavigate();

  const onClickHandler = () => {
    if (isHotdesking) {
      const data = colleague.HOTDESKING;
      const hotdeskData = {
        id: data.BOOK_ID,
        member: {
          id: colleague.COLLEAGUE.MEMBER_ID,
          name: colleague.COLLEAGUE.MEMBER_NM,
          role: colleague.COLLEAGUE.ROLE_NM,
          department: {
            id: colleague.COLLEAGUE.DEPARTMENT_ID,
            name: colleague.COLLEAGUE.DEPARTMENT_NM,
          },
        },
        resource: {
          id: data.RESOURCE_ID,
          type: data.RESOURCE_TYPE,
          title: data.RESOURCE_TITLE,
          location: {
            id: data.LOCATION_ID,
            title: data.LOCATION_TITLE,
            source: data.LOCATION_SOURCE,
            width: data.LOCATION_WIDTH,
            height: data.LOCATION_HEIGHT,
            departmentTitle: data.LOCATION_DEPARTMENT_NM,
            departmentId: data.LOCATION_DEPARTMENT_ID,
          },
          coordinateX: data.RESOURCE_COORDINATE_X,
          coordinateY: data.RESOURCE_COORDINATE_Y,
        },
        status: data.BOOK_STATUS,
        duration: data.BOOK_DURATION,
        checkInDttm: data.BOOK_CHECKIN,
        startDttm: data.BOOK_START,
        endDttm: data.BOOK_END,
      };

      navigate(process.env.REACT_APP_CLIENT_URL + "app/hotdesking", {
        replace: true,
        state: hotdeskData,
      });
    }
  };
  return (
    <div
      className={style.dept_card_container}
      onClick={onClickHandler}
      style={{ cursor: isHotdesking ? "pointer" : "default" }}
    >
      <div className={style.dept_card_wrapper}>
        <div className={style.personal_info}>
          <div className={style.pInfo_img_circle}>
            <Avatar />
          </div>
          <div className={style.pInfo_info}>
            <div className={style.name}>{colleague.COLLEAGUE.MEMBER_NM}</div>
            <div
              className={style.info}
            >{`${colleague.COLLEAGUE.DEPARTMENT_NM} | ${colleague.COLLEAGUE.ROLE_NM}`}</div>
          </div>
        </div>
        <div className={style.reserve_info}>
          {colleague.MEETING !== null ? (
            <div className={style.status}>
              <div
                className={style.circle}
                style={{ backgroundColor: "#1cb691" }}
              ></div>
              <div className={style.title}>회의 중</div>
            </div>
          ) : colleague.HOTDESKING !== null ? (
            <div className={style.status}>
              <div
                className={style.circle}
                style={{ backgroundColor: "#a3cc18" }}
              ></div>
              <div className={style.title}>Hot Desking</div>
            </div>
          ) : (
            <div className={style.status}></div>
          )}
          <div className={style.location}>
            {colleague.MEETING !== null
              ? colleague.MEETING.ENDPOINT_NAME
              : colleague.HOTDESKING !== null
              ? colleague.HOTDESKING.RESOURCE_TITLE
              : ""}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PersonalCard;
